/**
 * Product showcase bundle: label the item that is the section's own product.
 *
 * Rebuy renders the bundle items client-side and only prints its built-in
 * "This item:" label when the widget has an input product — which never happens
 * outside a PDP, so on the ritual pages neither item is marked.
 *
 * The wrapper carries the section's product id and the translated label, so this
 * matches Rebuy's own `product-id-<id>` class on each block and inserts the
 * label above that block's title.
 *
 * Rebuy re-renders on variant/option changes and mounts async, so a
 * MutationObserver re-runs the pass on every fresh render.
 */
(function () {
  'use strict';

  var LABEL_CLASS = 'knesko-bundle-this-item';

  function labelBlock(block, text) {
    var info = block.querySelector('.rebuy-product-info');
    var title = info && info.querySelector('.rebuy-product-title');
    if (!title || info.querySelector('.' + LABEL_CLASS)) return;

    var label = document.createElement('p');
    label.className = LABEL_CLASS;
    label.textContent = text;
    info.insertBefore(label, title);
  }

  function labelAll(wrapper) {
    var id = wrapper.getAttribute('data-showcase-product-id');
    var text = wrapper.getAttribute('data-this-item-label');
    if (!id || !text) return;

    var blocks = wrapper.querySelectorAll('.rebuy-product-block.product-id-' + id);
    for (var i = 0; i < blocks.length; i++) {
      labelBlock(blocks[i], text);
    }
  }

  function watch(wrapper) {
    var queued = false;

    var run = function () {
      queued = false;
      observer.disconnect();
      labelAll(wrapper);
      observer.observe(wrapper, { childList: true, subtree: true });
    };

    // Disconnected while labelling so our own DOM writes don't re-trigger it.
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(run);
    });

    run();
  }

  function init() {
    var wrappers = document.querySelectorAll('[data-showcase-product-id][data-this-item-label]');
    for (var i = 0; i < wrappers.length; i++) {
      watch(wrappers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
